import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import PageLayout from "./layouts/PageLayout";
import {
  CourtRentCalendar,
  CourtRentTime,
  ChoosingRoom,
  RacketRentCalendar,
  RacketRentTime,
  Cart,
  ProfileLayout,
  Payment,
  PaymentSuccess,
  PaymentError,
  PaymentConfirm,
  Contacts,
  School,
  Services,
  NotFound,
  PersonalTraining,
  Products,
  Storage,
} from "./pages";

import { CardList } from "./components";
import { LoginModal } from "./components";
import { WhatsNewModal } from "./components";

import { PageTitles } from "./resources/locale";

import "./styles/app.scss";
import {openModal, URLModal} from "react-url-modal";
import { History } from "./pages/Profile/pages/History";
import { Settings } from "./pages/Profile/pages/Settings";
import { Cards } from "./pages/Profile/pages/Cards";
import { Logout } from "./pages/Profile/pages/Logout";
import { AddCardPayment } from "./pages/Profile/pages/AddCardPayment";
import {About} from "./pages/AboutPage/About";
import {AboutApp} from "./pages/Profile/components/AboutApp/AboutApp";
import {CourtSchema} from "./pages/AboutPage/pages/CourtSchema/CourtSchema";
import {DirectionSchema} from "./pages/AboutPage/pages/DirectionSchema/DirectionSchema";
import {ClubPhoto} from "./pages/AboutPage/pages/ClubPhoto/ClubPhoto";
import {News} from "./pages/AboutPage/pages/News/News";
import {MoreNews} from "./pages/AboutPage/pages/MoreNews/MoreNews";
import {Rules} from "./pages/Rules/Rules";
import {Politics} from "./pages/Politics/Politics";
import {Feedback} from "./pages/Feedback/Feedback";
import MetaTags from "./components/MetaTags/MetaTags";
import GruntList from "./pages/Profile/components/GruntReserved/GruntReservedList";
import {AppInfo} from "./components/AppInfoModal";
import {useSelector} from "react-redux";
import {appInfo} from "./redux/app/selectors";
import {fetchIsServerDown} from "./redux/app/asyncAction";
import {useAppDispatch} from "./redux/store";
import { GamesList, Games } from "./pages";
import { Tournaments } from "./pages/Tournaments";
import JoinGameModal from "./pages/Games/modals/JoinGameModal/JoinGameModal";
import SuccessRequestSendModal from "./pages/Games/modals/SuccessRequestSendModal";
import CreateNewGameModal from "./pages/Games/modals/CreateNewGameModal";
import { SuccessDeleteGameModal } from "./pages/Games/modals/SuccessDeleteGameModal";
import { SuccessCreateGameModal } from "./pages/Games/modals/SuccessCreateGameModal";
import { SuccessCancelRequestModal } from "./pages/Games/modals/SuccessCancelRequestModal";
import { CreateNewTournamentModal } from "./pages/Tournaments/modals/CreateNewTournamentModal";
import { SuccessCreateTournamentModal } from "./pages/Tournaments/modals/SuccessCreateTournamentModal";
import { SuccessCancelTournamentRequestModal } from "./pages/Tournaments/modals/SuccessCancelTournamentRequestModal";
import { SuccessDeleteTournamentModal } from "./pages/Tournaments/modals/SuccessDeleteTournamentModal";
import JoinTournamentModal from "./pages/Tournaments/modals/JoinTournamentModal/JoinTournamentModal";
import TournamentApplicationsModal from "./pages/Tournaments/modals/TournamentApplicationsModal";
import EditTournamentModal from "./pages/Tournaments/modals/EditTournamentModal";

function App() {
  const location = useLocation()
  const dispatch = useAppDispatch();
  const {serverDown} = useSelector(appInfo)

  React.useEffect(() => {
    dispatch(fetchIsServerDown());
  }, [location])

  React.useEffect(() => {
    if (serverDown) {
      openModal({name: "appInfo"})
    }
  }, [serverDown])

  return (
    <>
      <URLModal
        modals={{
          login:LoginModal,
          appInfo:AppInfo,
          joinGame:JoinGameModal,
          successRequestSend:SuccessRequestSendModal,
          createNewGame:CreateNewGameModal,
          successCreateGame:SuccessCreateGameModal,
          successDeleteGame:SuccessDeleteGameModal,
          successCancelRequest:SuccessCancelRequestModal,
          createNewTournament:CreateNewTournamentModal,
          successCreateTournament:SuccessCreateTournamentModal,
          successCancelTournamentRequest:SuccessCancelTournamentRequestModal,
          successDeleteTournament:SuccessDeleteTournamentModal,
          joinTournament:JoinTournamentModal,
          tournamentApplications:TournamentApplicationsModal,
          editTournament:EditTournamentModal,
        }}
      />
      <WhatsNewModal />
      <MetaTags path={location.pathname}/>
      <Routes>
        <Route path="/" element={<PageLayout />}>
          <Route path="" element={<CourtRentCalendar title={PageTitles.COURT_RENT} />} />
          <Route
            path="choosing-room"
            element={<ChoosingRoom title={PageTitles.COURT_RENT} />}
          />
          <Route
            path="time-and-court"
            element={<CourtRentTime title={PageTitles.COURT_RENT} />}
          />

          <Route path="/services" element={<Services title={PageTitles.SERVICES} />}>
            <Route
              path="racket-calendar"
              element={<RacketRentCalendar title={PageTitles.RACKET_RENT} />}
            />
            <Route
              path="racket-calendar/time-and-racket"
              element={<RacketRentTime title={PageTitles.RACKET_RENT} />}
            />
            <Route
              path="products"
              element={<Products title={PageTitles.PRODUCTS} />}
            />
            <Route
              path="tennis-school"
              element={<School title={PageTitles.SCHOOL} />}
            />
            <Route
              path="personal-trainings"
              element={<PersonalTraining title={PageTitles.PERSONAL_TRAINING} />}
            />
            <Route
              path="storage"
              element={<Storage title={PageTitles.STORAGE} />}
            />
          </Route>

          <Route path="/about" element={<About title={PageTitles.ABOUT} />}>
            <Route path="court-layout" element={<CourtSchema />}/>
            <Route path="direction" element={<DirectionSchema/>}/>
            <Route path="photo/*" element={<ClubPhoto/>}/>
            <Route path="news/*" element={<News/>}/>
            <Route path="news/more" element={<MoreNews/>}/>
            <Route path="cards" element={<CardList />} />
            <Route path="history" element={<History />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          
          <Route path="/about-app" element={<AboutApp />} />

          <Route path="contacts" element={<Contacts title={PageTitles.CONTACTS} />} />
          <Route path="feedback" element={<Feedback title="Обратная связь" />} />
          
          <Route path="/padel" element={<GamesList />}>
            <Route path="games/*" element={<Games />} />
            <Route path="tournaments/*" element={<Tournaments />} />
          </Route>
    
          <Route
            path="rules"
            element={<Rules title={PageTitles.RULES}/>}
          />

          <Route
            path="privacy-policy"
            element={<Politics title={PageTitles.POLITICS}/>}
          />

          <Route path="/profile" element={<ProfileLayout title={PageTitles.PROFILE} />}>
            <Route path="cards" element={<Cards />} />
            <Route path="add-card" element={<AddCardPayment />} />
            <Route path="history" element={<History />} />
            <Route path="settings" element={<Settings />} />
            <Route path="logout" element={<Logout />} />
            <Route path="gruntReserve" element={<GruntList/>}/>
          </Route>
          
          <Route path="cart" element={<Cart title={PageTitles.CART} />} />
          <Route path="payment" element={<Payment title={PageTitles.PAYMENT} />} />
          <Route path="payment-confirm" element={<PaymentConfirm />} />
          <Route path="payment-success" element={<PaymentSuccess />}></Route>
          <Route path="payment-error" element={<PaymentError />}></Route>
          
          <Route path="*" element={<NotFound title={PageTitles.NOT_FOUND} />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
